import { debounce } from 'lodash-es';

export default class AdfShowHideHeader
{
    constructor ()
    {

        this.header = document.querySelector( '#site-header' );

        this.lastScroll = window.pageYOffset;


        this.measureHeaderHeight();
        this.bindEvents();
    }


    bindEvents ()
    {


        // let's not hide the header if it's still
        // on screen in its original position
        window.addEventListener( 'resize', debounce( () =>
        {
            this.measureHeaderHeight();
        }, 100 ) );


        window.addEventListener( "scroll", this.maybeAdjustHeader.bind( this ) );
    }

    measureHeaderHeight ()
    {
        this.headerHeight = this.header.getBoundingClientRect().height;
    }


    maybeAdjustHeader ()
    {
        let currentScroll = window.pageYOffset;
        // console.log( 'currentScroll', currentScroll, 'this.headerHeight', this.headerHeight, 'this.lastScroll', this.lastScroll, currentScroll < this.headerHeight );

        if ( currentScroll < this.headerHeight )
        {
            this.header.classList.remove( "hidden" );
            this.lastScroll = currentScroll;


            document.body.classList.remove('header-hidden');
            document.body.classList.add('header-visible');


            return;
        }


        if ( currentScroll - this.lastScroll > 0 )
        {
            // scrolling down
            // console.log('Scrolling down');
            this.header.classList.add( "hidden" );

            document.body.classList.add('header-hidden');
            document.body.classList.remove('header-visible');

        } else
        {
            // scrolling up
            // console.log('Scrolling up');
            this.header.classList.remove( "hidden" );

            document.body.classList.remove('header-hidden');
            document.body.classList.add('header-visible');
        }
        this.lastScroll = currentScroll;
    }
}
